<template>
  <div class="main">
    <Main v-if="!initialPage && isAuthorized">
    </Main>
    <InitialPage v-if="initialPage"></InitialPage>
  </div>
</template>

<script>
import Main from '../components/Main'
import InitialPage from '../components/InitialPage'
import {HTTP, HTTP_AUTH} from "@/main";

export default {
  name: 'home',
  computed : {
    isAuthorized() {
      return this.$store.state.user.isAuthorized;
    },
    initialPage() {
      return this.$store.state.initialPage;
    },
    remind(){
      return this.$store.state.panels.login.remind
    }
  },
  created : function () {
    if( window.location.search !== "" ){
      let t = window.location.search.substr(1).split("&");
      history.pushState({}, null, parent.location.origin);

      let remData = {};
      for( let i = 0; i < t.length; i++ ){
        let a = t[i].split("=");
        remData[a[0]] = a[1];
      }
      this.$store.dispatch('remindData', remData);

      if( this.remind.confirm ){
        if( this.remind.confirm === 'password' ){
          if( !this.initialPage ){
            this.$store.dispatch('toggleInitialPage');
          }
          setTimeout( () => {
            this.$store.dispatch('toggleLoginPanel');
            this.$store.dispatch('loginFormType', 'newPass');
          }, 300 );

          this.$store.dispatch( 'addAlert', { text : 'Пароль сброшен', type : 'success' });
        }else if( this.remind.confirm === 'email' ){
          if( !this.initialPage ){
            this.$store.dispatch('toggleInitialPage');
          }
          this.$store.dispatch('toggleLoginPanel');
          HTTP_AUTH.post('registration/verify-email/', {
            key     : decodeURIComponent(this.remind.key),
          }).then(() => {
            this.$store.dispatch( 'addAlert', { text : 'Email подтвержден', type : 'success' });
            this.$store.dispatch('loginFormType', 'userIsCreate')
          }).catch( error => {
            this.$store.dispatch('errorResponse', error );
          });
        }
      }else if( this.remind.buy ){
        if( !this.isAuthorized ){
          this.$store.dispatch( 'addAlert', { text : 'Невозможно совершить операцию. Вы не авторизованы', type : 'error' });
        }
      }else if( this.remind.token ){
        HTTP.defaults.headers.common['Authorization'] = 'Token ' + this.remind.token;
        document.cookie = "userToken=" + this.remind.token;
        document.cookie = 'activeCar=0';
        setTimeout(function () {
          window.location.reload();
        }, 100)
      }else if( this.remind.error ){
        this.$store.dispatch( 'addAlert', { text : decodeURI( remData.error ), type : 'error' });
      }
    }
  },
  components: {
    Main,
    InitialPage,
  }
}
</script>
